<template>
  <div>
    <el-select
      size="mini"
      placeholder="Servicio al Cliente"
      v-model="Customer_filter"
      filterable
      clearable
      @change="handleFilter"
    >
      <el-option
        v-for="(item, index) in customerList"
        :key="index"
        :value="item.Code"
        :label="item.FullName"
      >
        <span class="custom_option">
          <el-avatar size="small" :src="item.ImageUrl"></el-avatar>
          {{ item.FullName }}
        </span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "ClientRabbeyCustomerServiceSelector",

  data() {
    return {
      Customer_filter: "",
      customerList: []
    };
  },

  async mounted() {
    await this.list_customerservices();
  },

  methods: {
    async list_customerservices() {
      await this.$http
        .get(
          `/api/customers/AllCustomerServices?companyCode=${this.currentCompany}`
        )
        .then((resp) => {
          console.log("Customer Services response:", resp.data);
          this.customerList = resp.data.map((i) => {
            return {
              Code: i.Code,
              FullName: i.FullName,
              ImageUrl: i.ImageUrl
            };
          });
        })

        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    handleFilter(val) {
      this.$emit("CustomerServiceChanged", val);
    }
  }
};
</script>

<style scoped>
.custom_option {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
